import { render } from "./ActionsField.vue?vue&type=template&id=1c8c34de"
import script from "./ActionsField.vue?vue&type=script&lang=js"
export * from "./ActionsField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__